<template>
  <div class="edit_line">
    <button v-on:click.prevent="showEditForm = !showEditForm">Редактировать</button>
    <button class="cc_remove_item"v-on:click.prevent="delItem">Удалить</button>
    <div class="cc_item_tab" v-if="showEditForm">
      <input type="text" name="folderAddTitle" placeholder="Введите заголовок" v-model="item.title">
      <input type="text" name="folderAddSort" placeholder="Укажите порядковый номер в списке" v-model="item.sort">
      <vue-editor v-model="item.content" v-if="item.template != 'folder'"></vue-editor>
      <button class="cc_save_edit_item" v-on:click.prevent="editFolder">Сохранить</button>
    </div>
  </div>
</template>

<script>
  import { VueEditor } from "vue2-editor";
  export default {
    name: "editScriptsEditFolder",
    data(){
      return{
        folderAddTitle:'',
        folderAddSort:'',
        showEditForm:false,
      }
    },
    props:{
      item:{
        type:Object,
        default:()=>{
          return {}
        },
      },
      scriptID:{
        type:String,
        default:'0'
      }
    },
    components:{
      VueEditor
    },
    methods:{
      delItem(){
        let pr = confirm('Вы точно хотите удалить?');
        if (pr) {
          this.$myApi.singleRequest({
            action:'OperatorScript_delItem',
            id:this.item.id,
            scriptID:this.scriptID
          }).then((res)=>{
            console.log(res);
            this.$store.dispatch('loadScriptById',this.scriptID);
          }).catch((res)=>{
            alert(res);
          })
        }
      },
      editFolder(){
        this.$myApi.singleRequest({
          action:'OperatorScript_editFolder',
          title:this.item.title,
          sort:this.item.sort,
          id:this.item.id,
          content:this.item.content
        }).then((res)=>{
          console.log(res);
          this.$store.dispatch('loadScriptById',this.scriptID);
        }).catch((res)=>{
          alert(res);
        })
      }
    }
  }
</script>

<style scoped>

</style>
